import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ActivityAction } from '@stores/activity/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import { BASE_IMG_URL } from '@images/imageUrls';
import TabNav from '@components/tabNav';
import ActivityList from '@components/activityList';
import { formatNumberToWan } from '@utils/formatNumber'
import classNames from 'classnames';
import AvatarList from '@components/avatarList';
import { px2rem } from '@utils/px2rem';
import { listenScrollDirection, getScrollPosition } from '@utils/scrollUtils';

interface ActivityListH5PageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    activity?: ActivityAction;
    activityList?: any[];
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    navList?: any
    navCurrentIndex?: any
    navCurrentType?: any
    navClick?: Function
}
interface ActivityListH5State {
    loading: boolean;
    error: any
    pageLoaded: any
    scrollY: any
    scrollDirection: any
}
@inject('app', 'site', 'user', 'activity')
@observer
class ActivityListH5Page extends BasePage<ActivityListH5PageProps, ActivityListH5State> {
    // 作为类属性直接定义
    scrollCleanup = null;
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
        scrollY: 0, // 滚动高度
        scrollDirection: null,    // 滚动方向
    };
    async componentDidMount() {
        const { app, user, activity } = this.props;
        
        if (activity) {
            let params: any = {
                "page[number]": 1,
                "page[size]": 20
            }
            activity.getActivityList(params);
        }

        // 初始化窗口尺寸和滚动位置
        this.scrollCleanup = listenScrollDirection((scrollData) => {
            this.setState({ 
              scrollDirection: scrollData.direction,
              scrollY: scrollData.scrollY
            });
            this.handleScrollDirection(scrollData.direction, scrollData.scrollY);
        });
        super.componentDidMount();
    }
    // 检测滚动方法
    handleScrollDirection = (direction, scroll) => {
        // 处理滚动方向变化的逻辑
        // this.setState({ scrollY });
    };

    // 立即下载
    downloadClick = (id: string | number) => {
        // this.props.history && this.props.history.push(`/topic/${id}`);
    };

    // 活动列表
    renderActivityList = () => {
        const { activityList, loading, hasMore, onLoadMore } = this.props;
        return (
            <div style={{ marginBottom: 16 }}>
                <div>
                    <ActivityList 
                        data={activityList}
                        loading={loading}
                        hasMore={hasMore}
                        onLoadMore={onLoadMore}
                        emptyIcon={`${BASE_IMG_URL}/common/null.png`}
                    ></ActivityList>
                </div>
            </div>
        )
    }

    // 处理导航点击
    handleNavClick = (item: any, index: number) => {
        
        // 调用父组件传递的函数
        const { navClick } = this.props;
        if (navClick) {
            navClick(item, index);
        }
    }

    // 在组件中计算动态top值
    getDynamicTop = () => {
        const { scrollDirection } = this.state;
        const { site } = this.props;
        
        if (site?.appDownloadShowStatus) {
        // 下载入口显示时：下滑176px，上滑88px
        return scrollDirection === 'down' ? px2rem(88) : px2rem(176);
        } else {
        // 下载入口隐藏时：下滑0px，上滑88px
        return scrollDirection === 'down' ? px2rem(88) : px2rem(0);
        }
    }

    render() {
        let { navList, navCurrentIndex, navClick } = this.props;
        let { scrollY } = this.state;
        return (<div className={styles.wrapper}>
            {scrollY > 200 && <div className={styles.fixedNavFilterBox} style={{top: this.getDynamicTop()}}>
                <TabNav navList={navList} currentIndex={navCurrentIndex} navClick={(item:any, index:any) => this.handleNavClick(item, index)}></TabNav>
            </div>}
            {/* 悬浮置顶的导航 */}
            {/* <TabNav navList={navList} currentIndex={navCurrentIndex} navClick={(item:any, index:any) => this.navClick(item, index)}></TabNav> */}
            <div className={styles.navBox}>
                <TabNav navList={navList} isAlignLeft={true} currentIndex={navCurrentIndex} navClick={(item:any, index:any) => this.handleNavClick(item, index)}></TabNav>
            </div>
            <div className={styles.activityContent}>
                {this.renderActivityList()}
            </div>


        </div>)
    }
}

export default withRouter(ActivityListH5Page);
